import React, { useRef } from "react";
import { uploadTicketFile } from "../../../../api/files";

type Props = {
  ticketId: number;
  onUploadComplete: () => void;
};

export default function UploadButton({ ticketId, onUploadComplete }: Props) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    try {
      await uploadTicketFile(ticketId, file, undefined);
      onUploadComplete();
    } catch (err) {
      console.error("Upload failed", err);
    } finally {
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        onChange={handleChange}
        aria-label="Upload attachment"
      />
      <button
        type="button"
        onClick={handleClick}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-md border border-slate-200 bg-white text-sm font-medium text-slate-700 hover:bg-slate-50"
      >
        <span className="text-lg">⬆️</span>
        Upload
      </button>
    </>
  );
}
